import React, { useState, useEffect } from "react";
import { Box, Flex, Select, Text, Tabs, TabList, Tab, Badge } from "@chakra-ui/react";
import PrSrDocumentTable from "./PrSrDocumentTable";
import { appRequest } from "routes";

const PrSrDocuments = () => {
  const [selectedProcess, setSelectedProcess] = useState("pr");
  const [tabIndex, setTabIndex] = useState(0);
  const [counts, setCounts] = useState({ pending: 0, approved: 0, rejected: 0 });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const response: any = await appRequest("prSrDocument", "getPrSrCount", {
          processName: selectedProcess,
          processType: "NonPo",
        });
        if (response && response.status === "success") {
          setCounts({
            pending: response.pendingCount || 0,
            approved: response.approvedCount || 0,
            rejected: response.rejectedCount || 0,
          });
        }
      } catch (error) {
        console.error("Failed to fetch PR/SR counts", error);
      }
    };
    fetchCounts();
  }, [selectedProcess]);

  const statusName = tabIndex === 0 ? "Pending Approval" : tabIndex === 1 ? "Approved" : "Rejected";
  const statusType = tabIndex === 0 ? "pending" : tabIndex === 1 ? "approved" : "rejected";

  return (
    <Box bg="gray.50" minH="100vh" p={4}>
      <Flex 
        bg="white" 
        rounded="lg" 
        shadow="sm" 
        border="1px solid" 
        borderColor="gray.100"
        p={3}
        px={5}
        mb={4}
        align="center" 
        justify="space-between"
      >
        <Flex bg="gray.100" p={1} rounded="lg" gap={1}>
          <Box
            as="button"
            px={5} py={2}
            rounded="full"
            fontSize="sm"
            fontWeight="bold"
            transition="all 0.3s ease"
            bg={tabIndex === 0 ? "teal.500" : "transparent"}
            color={tabIndex === 0 ? "white" : "gray.600"}
            shadow={tabIndex === 0 ? "md" : "none"}
            _hover={{ bg: tabIndex === 0 ? "teal.600" : "gray.200" }}
            onClick={() => setTabIndex(0)}
            display="flex"
            alignItems="center"
            gap={2}
          >
            Pending
            <Flex
              align="center"
              justify="center"
              bg={tabIndex === 0 ? "white" : "gray.300"}
              color={tabIndex === 0 ? "teal.700" : "gray.700"}
              fontSize="xs"
              fontWeight="900"
              rounded="full"
              minW="22px"
              h="22px"
              px={1.5}
            >
              {counts.pending}
            </Flex>
          </Box>
          <Box
            as="button"
            px={5} py={2}
            rounded="full"
            fontSize="sm"
            fontWeight="bold"
            transition="all 0.3s ease"
            bg={tabIndex === 1 ? "teal.500" : "transparent"}
            color={tabIndex === 1 ? "white" : "gray.600"}
            shadow={tabIndex === 1 ? "md" : "none"}
            _hover={{ bg: tabIndex === 1 ? "teal.600" : "gray.200" }}
            onClick={() => setTabIndex(1)}
            display="flex"
            alignItems="center"
            gap={2}
          >
            Approved
            <Flex
              align="center"
              justify="center"
              bg={tabIndex === 1 ? "white" : "gray.300"}
              color={tabIndex === 1 ? "teal.700" : "gray.700"}
              fontSize="xs"
              fontWeight="900"
              rounded="full"
              minW="22px"
              h="22px"
              px={1.5}
            >
              {counts.approved}
            </Flex>
          </Box>
          <Box
            as="button"
            px={5} py={2}
            rounded="full"
            fontSize="sm"
            fontWeight="bold"
            transition="all 0.3s ease"
            bg={tabIndex === 2 ? "red.500" : "transparent"}
            color={tabIndex === 2 ? "white" : "gray.600"}
            shadow={tabIndex === 2 ? "md" : "none"}
            _hover={{ bg: tabIndex === 2 ? "red.600" : "gray.200" }}
            onClick={() => setTabIndex(2)}
            display="flex"
            alignItems="center"
            gap={2}
          >
            Rejected
            <Flex
              align="center"
              justify="center"
              bg={tabIndex === 2 ? "white" : "gray.300"}
              color={tabIndex === 2 ? "red.700" : "gray.700"}
              fontSize="xs"
              fontWeight="900"
              rounded="full"
              minW="22px"
              h="22px"
              px={1.5}
            >
              {counts.rejected}
            </Flex>
          </Box>
        </Flex>

        <Flex align="center" gap={4}>
          <Text fontWeight="600" color="gray.600" fontSize="sm" textTransform="uppercase" letterSpacing="wide">
            Process Type
          </Text>
          <Select 
            value={selectedProcess} 
            onChange={(e) => setSelectedProcess(e.target.value)}
            bg="gray.50"
            size="sm"
            rounded="md"
            border="none"
            w="240px"
            _hover={{ bg: "gray.100" }}
            _focus={{ bg: "white", boxShadow: "outline" }}
            fontWeight="600"
            color="teal.700"
            cursor="pointer"
          >
            <option value="pr">Purchase Request (PR)</option>
            <option value="sr">Service Request (SR)</option>
          </Select>
        </Flex>
      </Flex>
      
      <Box>
        <PrSrDocumentTable
          name={statusName}
          type={statusType}
          activePage={statusName}
          isDisabled={false}
          isManual={true}
          customProcessName={selectedProcess}
        />
      </Box>
    </Box>
  );
};

export default PrSrDocuments;
